import React from 'react';
import { X } from 'lucide-react';

export const ImageModal = ({ selectedImage, onClose }) => {
  if (!selectedImage) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleImageClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
      onClick={handleBackdropClick}
    >
      <div className="relative max-w-4xl max-h-4xl p-4">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 z-10 bg-black bg-opacity-50 text-white rounded-full p-2 hover:bg-opacity-75 transition-all duration-200"
          aria-label="Close image modal"
        >
          <X size={20} />
        </button>
        
        <img
          src={selectedImage.url}
          alt={selectedImage.file.name}
          className="max-w-full max-h-full object-contain rounded-lg"
          onClick={handleImageClick}
        />
        
        <div className="absolute bottom-4 left-4 bg-black bg-opacity-50 text-white px-3 py-1 rounded text-sm">
          {selectedImage.file.name}
        </div>
      </div>
    </div>
  );
};